@if(isLoading$ | async){
<div class="overlay">
  <img src="assets/spinner_giallo.gif" alt="loader" />
</div>
}
